import createIcon from '../../createIcon';

/**
 * @component @name Medication
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggM0g2VjVIMThWM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNyA2SDdDNS45IDYgNSA2LjkgNSA4VjE5QzUgMjAuMSA1LjkgMjEgNyAyMUgxN0MxOC4xIDIxIDE5IDIwLjEgMTkgMTlWOEMxOSA2LjkgMTguMSA2IDE3IDZaTTE2IDE1SDEzLjVWMTcuNUgxMC41VjE1SDhWMTJIMTAuNVY5LjVIMTMuNVYxMkgxNlYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Medication = createIcon('Medication', [
  ['path', { d: 'M18 3H6V5H18V3Z', key: 'glnywg' }],
  [
    'path',
    {
      d: 'M17 6H7C5.9 6 5 6.9 5 8V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V8C19 6.9 18.1 6 17 6ZM16 15H13.5V17.5H10.5V15H8V12H10.5V9.5H13.5V12H16V15Z',
      key: 'cczslb',
    },
  ],
]);

export default Medication;
